const SELECTORS = {
  swiperContainer: '.js-header-hero__collection-swiper',
};
/**
 * Initialize swiper
 *
 * @param {object} Swiper swiper class object
 */
const initQualityCardSlider = (Swiper) => {
  const swiperContainer = document.querySelector(SELECTORS.swiperContainer);
  const swiperOptions = {
    slidesPerView: 3.5,
    loop: false,
  };
  if (swiperContainer) {
    // eslint-disable-next-line no-new
    new Swiper(swiperContainer, swiperOptions);
  }
};
const widthActual = window.innerWidth;
const mobileWidth = 650;
/**
 * Checks if the current device is considered a mobile device based on the window width.
 *
 * @function isMobileDevice
 * @returns {boolean} - Returns true if the window width is less than or equal to 650 pixels, indicating a mobile device.
 */
const isMobileDevice = () => {
  return window.innerWidth <= mobileWidth;
};

document.addEventListener('DOMContentLoaded', () => {
  window.LoadSwiper.then((module) => {
    if (isMobileDevice()) {
      initQualityCardSlider(module.Swiper);
    }
  });
});

/**
 *
 */
function reloadPage() {
  // eslint-disable-next-line no-restricted-globals
  location.reload();
}
window.addEventListener('resize', () => {
  const width = window.innerWidth;
  if (widthActual > mobileWidth && width < mobileWidth) {
    reloadPage();
  }
  if (widthActual < mobileWidth && width > mobileWidth) {
    reloadPage();
  }
});
